export default __webpack_public_path__ + "static/phones-desktop-07c8029de83d54141f9c603018ecae1d.png";